import React from 'react';
import { format } from 'date-fns';
import { useCountdown } from '../hooks/useCountdown';
export function OfferCountdown() {
  const {
    minutes,
    seconds
  } = useCountdown(15 * 60 - 27);
  const today = format(new Date(), 'EEEE, MMMM d');
  return <div className="rounded-2xl border border-cream-300 bg-cream-50 px-6 py-7 text-center" data-id="element-43" data-mp="24xlrsox4qght">
      <p className="font-display text-[21px] font-semibold tracking-[-0.01em] text-gold-500" data-id="element-44" data-mp="28xvv1ttjessz">
        Launch offer
      </p>
      <p className="mt-3 text-[12px] font-semibold uppercase tracking-[0.16em] text-ink-500" data-id="element-45" data-mp="1cahl8fie1u3x">
        This offer expires
      </p>
      <p className="mt-1 font-display text-[17px] font-semibold text-ink-900" data-id="element-46" data-mp="1l8bd9e94e1la">Today, {today}</p>

      <p className="mt-5 text-[14.5px] leading-[1.6] text-ink-500" data-id="element-47" data-mp="1q8flkgzvjq0f">
        Your spot will be reserved for <span className="font-semibold text-ink-900" data-id="element-48" data-mp="2wohw3154jcth">15 minutes</span>.
        After that, the discount goes to the next person.
      </p>

      <div className="mt-6 flex items-stretch justify-center gap-3" data-id="element-49" data-mp="31li1ray2adk2">
        <TimeBox value={minutes} label="Minutes" data-id="element-50" data-mp="26q301ibb762s" />
        <TimeBox value={seconds} label="Seconds" data-id="element-51" data-mp="26nqgx1ttepo5" />
      </div>
    </div>;
}
type TimeBoxProps = {
  value: string;
  label: string;
};
function TimeBox({
  value,
  label
}: TimeBoxProps) {
  return <div className="w-[118px] rounded-xl border border-cream-300 bg-white px-4 py-3.5" data-id="element-52" data-mp="1wtq6ckfrks81">
      <p className="font-display text-[28px] font-semibold leading-none tracking-[-0.02em] text-ink-900" data-id="element-53" data-mp="1rsanmz126xst">
        {value}
      </p>
      <p className="mt-1.5 text-[11px] font-semibold uppercase tracking-[0.16em] text-ink-500" data-id="element-54" data-mp="1j08kuu3ip5fd">
        {label}
      </p>
    </div>;
}